import { LogoutOutlined, WarningOutlined } from '@ant-design/icons'
import { Button, Layout, Menu } from 'antd'
import { MenuItem } from './siderMenu'
import Logo from '../../images/pejlen_liggande.svg'
const { Sider } = Layout

export const FakePejlenSidebar = () => {
  return (
    <Sider
      theme="light"
      breakpoint={'lg'}
      collapsedWidth="60px"
      collapsible
      collapsed={false}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'sticky',
        top: 0,
        left: 0,
      }}
    >
      <div>
        <div className="logo">
          <img src={Logo} alt="Inrikta logga" width={'90%'} />
        </div>
        <Menu mode="inline" selectedKeys={[]} defaultSelectedKeys={[window.location.pathname]} style={{ width: '200px' }} items={[]} />
      </div>
      <div className="menu-button-wrapper">
        <>
          <Button className="button-no-hover" style={{ paddingLeft: '40px' }} type="text">
            <LogoutOutlined />
            Logga ut
          </Button>
        </>
      </div>
    </Sider>
  )
}
